import { Anchor, Button, InfoModal, useModal } from "@newsela/angelou";
import PropTypes from "prop-types";

import ActionButtonList from "@/components/ActionButtonList/ActionButtonList";
import {
  buttonStyles,
  modalStyles,
  subtitleStyles,
} from "./AdminConsoleSchoolGeneralInformationValidationModal.style";

const SUPPORT_URL = "https://support.newsela.com/contact/";

const propTypes = {
  onSubmit: PropTypes.func.isRequired,
  canEdit: PropTypes.bool.isRequired,
  // Check that the school is licensed
  schoolIsLicensed: PropTypes.bool.isRequired,
};

const AdminConsoleSchoolGeneralInformationValidationModal = ({
  onSubmit,
  canEdit,
  schoolIsLicensed,
}) => {
  const [modalProps, setActive] = useModal(false);
  const handleValidateSchool = (status) => {
    onSubmit({ status: { value: status } });
    setActive(false);
  };

  return (
    <>
      <Button
        flavor={Button.flavors.primary}
        onClick={() => setActive(true)}
        __cssFor={buttonStyles}
        aria-label="Review status"
        disabled={!canEdit}
      >
        Review status
      </Button>
      <InfoModal
        __cssFor={modalStyles}
        labelId="ValidateSchool"
        title="Validate school"
        onBackgroundClick={() => setActive(false)}
        footer={
          <ActionButtonList
            actionsList={[
              {
                label: "Deactivate school",
                flavor: Button.flavors.danger,
                handleClick: () => handleValidateSchool(false),
                disabled: schoolIsLicensed,
              },
              {
                label: "Validate school",
                flavor: Button.flavors.primary,
                handleClick: () => handleValidateSchool(true),
              },
            ]}
          />
        }
        {...modalProps}
      >
        <p css={subtitleStyles}>
          Validate this school to ensure it appears correctly in the district's
          data reports
          {!schoolIsLicensed &&
            "—or, remove the school from the district instead."}
        </p>
        <p css={subtitleStyles}>
          Is this school a duplicate? To merge schools, send their names
          to&nbsp;
          <Anchor
            href={SUPPORT_URL}
            openInNewTab
            isInline
            __css={{ cursor: "pointer" }}
            ariaProps={{
              "aria-label": "Newsela support",
            }}
          >
            Newsela support.
          </Anchor>
        </p>
      </InfoModal>
    </>
  );
};

AdminConsoleSchoolGeneralInformationValidationModal.propTypes = propTypes;

export default AdminConsoleSchoolGeneralInformationValidationModal;
